module.exports = __webpack_public_path__ + "static/media/rugrats-post-game-squad.77d4b5a6.png";